import type {EmergencyPr} from './emergency'
export type BundlePr=EmergencyPr&{pr_body?:string;title?:string;blocker?:string;explanation?:string;approved_sha?:string|null}
export function declaredDependencies(pr:BundlePr){
 const urls:string[]=[],errors:string[]=[]
 for(const line of (pr.pr_body??'').split(/\r?\n/)){
  const m=line.match(/^\s*(?:Depends-On|Depends on)\s*:\s*(.+)$/i);if(!m)continue
  for(const token of m[1].split(/[,\s]+/).filter(Boolean)){
   const local=token.match(/^#([1-9]\d*)$/),full=token.match(/^https:\/\/github\.com\/(the-Otomator\/[\w.-]+)\/pull\/([1-9]\d*)$/),qualified=token.match(/^(the-Otomator\/[\w.-]+)#([1-9]\d*)$/)
   if(local)urls.push(`https://github.com/${pr.repo}/pull/${local[1]}`)
   else if(full)urls.push(token)
   else if(qualified)urls.push(`https://github.com/${qualified[1]}/pull/${qualified[2]}`)
   else errors.push(`#${pr.number}: הצהרת תלות לא מזוהה: ${token}. יש לציין Depends-On: וקישור PR מלא או #מספר.`)
  }
 }
 return {urls:[...new Set(urls)],errors}
}
export function releaseBundle(taskId:string,roots:string[],prs:BundlePr[],extra:string[]=[]){
 const byUrl=new Map(prs.map(p=>[p.url,p])),required=[...new Set([...roots,...prs.filter(p=>p.task?.id===taskId&&p.state==='open').map(p=>p.url)])]
 const selected=[...new Set([...required,...extra])],order:BundlePr[]=[],errors:string[]=[],visiting=new Set<string>(),done=new Set<string>(),edges:Record<string,string[]>={}
 function visit(url:string){
  if(visiting.has(url)){errors.push('תלות מעגלית בשחרור: '+url);return}
  if(done.has(url))return
  const p=byUrl.get(url)
  if(!p){errors.push('חסר מידע מאומת על שינוי נדרש: '+url+'. יש לסנכרן או לאמת שכבר מוזג; לא מניחים שהתלות הושלמה.');done.add(url);return}
  visiting.add(url)
  const deps=p.state==='merged'?{urls:[],errors:[]}:declaredDependencies(p);edges[url]=deps.urls;errors.push(...deps.errors)
  for(const dependency of deps.urls)visit(dependency)
  visiting.delete(url);done.add(url);order.push(p)
 }
 for(const url of selected)visit(url)
 return {required,order,edges,errors:[...new Set(errors)],queue:prs.filter(p=>p.state==='open'),selected:new Set(order.map(p=>p.url)),tasks:Object.fromEntries(order.filter(p=>p.task?.id).map(p=>[p.url,p.task!.id]))}
}
